/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-06 15:49:17
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-26 20:03:34
 */
import React from 'react';
import './TabVoteList.less';
import { Spin } from 'antd';
import * as models from '@services/model/models';
import { SFCVoteTextImage, SFCPagination, NoData } from '..';
import { PAGE_SIZE } from '@src/utils/constant/common';

export interface ITabVoteListProps {
  /** 加载装态 */
  loading: boolean;
  /**数据 */
  voteModel: models.PageableResultVoteQuestionSimplePO;
  /** 关注取关 */
  toggleFollow: (data: { voteQuestionId: number; targetType: boolean }) => void;
  /** 页码切换 */
  changePage: (pageNum: number) => void;
  /** 个人页面 */
  personal?: boolean;
  /** 投票删除 */
  removeVoteList?: (voteQuestionId: number) => void;
}
type Props = ITabVoteListProps;

export function TabVoteList(props: Readonly<Props>) {
  const {
    loading,
    voteModel,
    voteModel: { list = [] },
    toggleFollow,
    changePage,
    personal = false,
    removeVoteList
  } = props;

  const handleRemove = (voteQuestionId: number) => {
    removeVoteList && removeVoteList(voteQuestionId);
  };

  return (
    <div className="common-presenter k-common-tab-vote-list">
      <Spin className="common-presenter k-circle-ask-list" spinning={loading}>
        {list.map((item, index) => {
          item[`isFollowing`] = item[`isFollowing`] || false;
          return (
            <SFCVoteTextImage
              data={item}
              index={index}
              onFollow={toggleFollow}
              key={item.voteQuestionId}
              personal={personal}
              handleRemove={handleRemove}
            />
          );
        })}
        {list.length > 0 ? (
          <SFCPagination
            pageNum={voteModel.pageNum || 1}
            pageSize={voteModel.pageSize || PAGE_SIZE}
            total={voteModel.total || 0}
            onChange={changePage}
          />
        ) : (
          <NoData show={true} />
        )}
      </Spin>
    </div>
  );
}

export default TabVoteList;
